import { History } from 'history';
import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { HotelsLeftSide } from '../hotels/HotelsLeftSide'; 
import { CMS, HotelBedCatalogData, HotelBedData } from '../shared/index';
import { getOnlyFromCacheHotelCategoryCatalog } from '../utils/index';
import { HotelSearchResultWithUrlReqKeyMainPanel } from 'src/hotels/HotelSearchResultWithUrlReqKeyMainPanel';
import { sendHotelAvailibilityRequest } from 'src/utils/req-available-helper'; 
export interface IndexPromotionsProps extends BaseComponentProps {
    // id: string | number;
    lang: string;
    currency: string;
    data: CMS.CmsPromotion;
    pageSize: number;
    history?: History | any;
    wishlistCount: (c: number) => any;
    /** 
     * filter awal untuk data
     */
    initialFilter: HotelBedData.SearchFilter;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    newRequestAvailability: (dari: string) => any;
    /**
     * real time database ref
     */
    realtimeDb: firebase.database.Database;

    firestoreDb: firebase.firestore.Firestore;
    updateInternalFilter: (filter: HotelBedData.SearchFilter) => any;
    /**
     * firebase uuid
     */
    uuid: string;
    firebaseApp: firebase.app.App;
    // responKey: string;
    pageChange: (page: number, dari: string) => any;
    page: number;
}
export interface IndexPromotionsState extends BaseComponentState {
    data: CMS.CmsPromotion;
    hotelDetail?: any;
    page: number;
    hotelCodes: number[];
    responKey?: string | any;
    hotels: HotelBedData.PagedHotelbedData | any;
    externalFilter: HotelBedData.ExternalFilter | any;
    currentFilter: HotelBedData.SearchFilter | any;
    requesting: boolean;
    error: boolean;
    errorMessage: string | any;
    filterRateChange: boolean;

    filterRate: {
        maxRate: number,
        minRate: number
    };
    indexedCategoryData: { [id: string]: HotelBedCatalogData.Category };
    version: number;
    leftPanelRequesting: string;
    panelState: 'NEW_REQ_AVAILABLE' | 'REQ_AVAILABLE_READY';

}

export class IndexPromotions extends BaseComponent<IndexPromotionsProps, IndexPromotionsState> {

    /**
     * field pada props untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_PROPS: string[] = ['lang', 'currency'];
    /**
     * field yang di compare pada state untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_STATE: string[] = ['hotels', 'page', 'error', 'errorMessage', 'panelState', 'requesting'];

    /**
     * panel sisi kiri
     */
    leftSidePanel: HotelsLeftSide;
    /**
     * Panel untuk list hotels
     */
    hotelMainPanel: HotelSearchResultWithUrlReqKeyMainPanel;

    timeout: any = null;

    constructor(props: IndexPromotionsProps) {
        super(props);
        this.state = {
            panelState: 'NEW_REQ_AVAILABLE',
            data: props.data,
            page: 0,
            hotelCodes: [],
            hotels: null,
            externalFilter: null,
            requesting: true,
            error: false,
            errorMessage: null,
            currentFilter: null,
            filterRateChange: false,
            filterRate: {
                maxRate: 100000000,
                minRate: 0
            },
            indexedCategoryData: getOnlyFromCacheHotelCategoryCatalog(),
            version: 0,
            leftPanelRequesting: 'request'
        };
    }

    shouldComponentUpdate(nextProps: IndexPromotionsProps, nextState: IndexPromotionsState): boolean {
        if (this.compareForShouldComponentUpdateStateOrProp(IndexPromotions.FIELD_COMPARED_PROPS, this.props, nextProps)) {
            return true;
        }
        if (this.compareForShouldComponentUpdateStateOrProp(IndexPromotions.FIELD_COMPARED_STATE, this.state, nextState)) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        this.getData();
    }
    getData: () => any = () => {

        sendHotelAvailibilityRequest({ filter: this.props.initialFilter , app: this.props.firebaseApp}).then(
            d => {
                this.setStateHelper(
                    (st: any) => {
                        st.responKey = d.responKey;
                        window["responKey"] = d.responKey;
                        // st.hotelCodes = d.hotelCodes;
                        let filter: HotelBedData.SearchFilter | any = this.props.initialFilter; // getStringFilter(d.filter!);
                        st.currentFilter = filter;
                        st.panelState = 'REQ_AVAILABLE_READY';
                    }  

                ); 
            }
        ).catch(
            err => {
                console.log(err);
            }
        );
         
    }

    render() {
        const props = this.props;
        const state = this.state;
        console.log(props);
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        if (this.state.panelState === 'REQ_AVAILABLE_READY') {
            return (
                <HotelSearchResultWithUrlReqKeyMainPanel
                    ref={d => {this.hotelMainPanel = d as any; window["hotelMainPanel"] = d; console.log("Simpan hotelMainPanel", this.hotelMainPanel); }}
                    responKey={this.state.responKey}
                    currency={props.currency}
                    history={props.history}
                    lang={this.props.lang}
                    initialFilter={state.currentFilter}
                    getHotels={this.props.getHotels}
                    pageSize={15}
                    newRequestAvailability={props.newRequestAvailability}
                    realtimeDb={props.realtimeDb}
                    firestoreDb={props.firestoreDb}
                    updateInternalFilter={props.updateInternalFilter}
                    wishlistCount={this.wishlistCount}
                    uuid={props.uuid}
                    fromSlug="promotions"
                    slugData={this.state.data.promotionCodes}
                    firebaseApp={this.props.firebaseApp}
                    pageChange={this.props.pageChange}
                    page={this.props.page}
                />
            );
        }
        return <span>TDADADA</span>;
    }

    wishlistCount: (n: any) => any = n => {
        //
    }
}



// WEBPACK FOOTER //
// ./src/cms/IndexPromotions.tsx